import React, { FC } from "react";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as ArrowIcon } from "src/assets/icons/arrow.svg";

export const ControlsPanel: FC = () => {
  return (
    <div className="hidden md:block">
      <Button
        className="absolute bottom-45 left-5 button-prev"
        variant={ButtonVariants.OPACITY_GRAY}
      >
        <ArrowIcon />
      </Button>

      <Button
        className="absolute bottom-45 right-110 2xl:right-175 button-next"
        variant={ButtonVariants.OPACITY_GRAY}
      >
        <ArrowIcon className="rotate-180" />
      </Button>
    </div>
  );
};
